document.addEventListener("DOMContentLoaded", function () {
  if (!bot) {
    let loadContainers = document.querySelectorAll(".load-container");
    loadContainers.forEach(function (item) {
      let delay = item.dataset.delay || 10;

      setTimeout(function () {
        fetch(`//${window.location.host}${item.dataset.href}`, {
          method: "GET",
        })
          .then((data) => data.text())
          .then(
            (data) => {
              document.getElementById(item.id).innerHTML += data;
              document.getElementById(item.id).style.display = "block";
              if (document.getElementById(item.id).querySelector(".loader")) {
                document
                  .getElementById(item.id)
                  .querySelector(".loader")
                  .remove();
              }
              document.getElementById(item.id).classList.remove("hidden");

              return document.getElementById(item.id).children.length > 0
                ? document.getElementById(item.id).children[0].length
                : 0;
            },
            (data) => console.log(data)
          );
      }, delay);
    });
  }
});
